import api from './index'
import {
	axios,
	pureAxios
} from '@/utils/request'

export const routerMap = {
	'leave': 'leave',
	's-leave': 'leave',
	'purchase': 'purchase',
	'scrapped': 'scrapped',
	'scrap': 'scrap', //报废

}

export const modalMap = {
	'leave': 'leavemodal',
	's-leave': 'leavemodal',
	'purchase': 'purchasemodal', //采购
	'scrapped': 'scrapmodal', //报废
	'claim': 'receiveModal', //申领
	'businessMoney': 'operationmodal', //业务费申请
	'review': 'servicemodal', //评审服务费申请
	'reimburse': 'reimbursementmodal', //报销申请
	'payment': 'paymentmodal',
	'contract_ys': 'contractmodal',
	'seal': 'sealmodal', //用印申请
	'universal': 'currencymodal', //通用申请
	'goodsRejected': 'returnmodal', //退货申请
	'carApply': 'carmodal', //用车申请
	'carSubsidyApply': 'returncarmodal', //还车补贴
	'xz_approval': 'salarymodal', //薪资核准
	'xz_adjustment': 'adjustmentmodal', //薪资调整
	'cover': 'chargemodal', //服务费申请
	'other-charge': 'othermodal', //其他费用申请
	'feedback': 'feedbackmodal', //需求反馈
	'hcpd': 'inventorymodal', //耗材盘点
	'pr_amount': 'salaryEditModal' ,//修改金额,
	'quotation': 'quotation',//报价
	'contract-review': 'contractReview',//合同评审
	'bid': 'tender',//投标
	'contract-project': 'contractDetail',//项目修改
	'project-terminate': 'terminationModal'//项目中止
}

export const statusMap = {
	'1': '审批中',
	'2': '结束',
	'3': '撤销',
	'4': '中止'
}
export const resultMap = {
	'1': '审批中',
	'2': '通过',
	'3': '驳回',
	'4': '撤销',
	'6': '中止'
}

export const deployByFileURL = api.process + '/deployByFile'

export function getModelList(parameter) {
	return axios({
		url: api.models + '/list',
		method: 'get',
		params: parameter
	})
}
export function getmodelerBaseUrl() {
	return axios({
		url: api.gateway_act + '/models/newModel?time=' + new Date().getTime(),
		method: 'get'
	})
}
export function delModel(parameter) {
	return axios({
		url: api.models + '/remove',
		method: 'post',
		params: parameter
	})
}
export function deploy(id) {
	return axios({
		url: api.models + '/deploy/' + `${id}`,
		method: 'post'
	})
}

export function getProfList(parameter) {
	return axios({
		url: api.prof + '/list',
		method: 'get',
		params: parameter
	})
}
export function getProfAllLatest(parameter) {
	return axios({
		url: api.prof + '/allLatest',
		method: 'get',
		params: parameter
	})
}

export function delProf(parameter) {
	return axios({
		url: api.prof + '/remove',
		method: 'post',
		params: parameter
	})
}

export function diagram(did) {
	return pureAxios({
		url: api.process + '/show?ext=.png&did=' + `${did}`,
		method: 'get',
		responseType: 'blob'
	})
}

export function modelXml(did) {
	return pureAxios({
		url: api.process + '/show?ext=.bpmn&did=' + `${did}`,
		method: 'get',
		responseType: 'blob'
	})
}

export function processState(processId, state) {
	return axios({
		url: api.process + '/update/' + `${processId}` + '/' + `${state}`,
		method: 'post'
	})
}

export function getProfInfRuns(parameter) {
	return axios({
		url: api.processIns + '/runs',
		method: 'get',
		params: parameter
	})
}
export function getProfInfFinished(parameter) {
	return axios({
		url: api.processIns + '/finished',
		method: 'get',
		params: parameter
	})
}

export function processInsState(procInstId, state) {
	return axios({
		url: api.processIns + '/update/' + `${procInstId}` + '/' + `${state}`,
		method: 'post'
	})
}
/**
 * 删除流程实例 撤销申请
 * @param {*} parameter
 */
export function delProcessIns(parameter) {
	return axios({
		url: api.processIns + '/remove',
		method: 'post',
		params: parameter
	})
}
export function delHiProcessIns(parameter) {
	return axios({
		url: api.processIns + '/remove/his',
		method: 'post',
		params: parameter
	})
}
// 我的申请（未删除）
export function getBusinessListMy(parameter) {
	return axios({
		url: api.business + '/list/my',
		method: 'get',
		params: parameter
	})
}
//获取关联的我的申请审批单
export function getBusinessListMyData(parameter) {
	return axios({
		url: api.business + '/list/my/relate',
		method: 'get',
		params: parameter
	})
}
//获取采购物品供应商信息
export function purchase_apply_quote(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_apply/quote/?id=' + parameter,
		method: 'get',
	})
}
//
export function purchase_apply_post(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_apply/quote',
		method: 'post',
		data: parameter
	})
}
export function saveBusiness(parameter) {
	return axios({
		url: api.business + (parameter.id > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}

export function auditTask(parameter) {
	return axios({
		url: api.task + '/audit',
		method: 'post',
		data: parameter
	})
}
export function auditTaskBatch(parameter) {
	return axios({
		url: api.task + '/audit/batch',
		method: 'post',
		data: parameter
	})
}

export function delBusiness(parameter) {
	return axios({
		url: api.business + '/remove',
		method: 'post',
		params: parameter
	})
}

export function getLeaveByBusiness(key) {
	return axios({
		url: api.leave + '/biz/' + `${key}`,
		method: 'get'
	})
}

export function getBusinessFeeApply(key) {
	return axios({
		url: api.gateway_act + 'business_fee_apply/biz/' + `${key}`,
		method: 'get'
	})
}
export function getCoverApply(key) {
	return axios({
		url: api.gateway_act + 'cover_apply/biz/' + `${key}`,
		method: 'get'
	})
}
export function getOtherApply(key) {
	return axios({
		url: api.gateway_act + 'other_apply/biz/' + `${key}`,
		method: 'get'
	})
}
export function getReviewApply(key) {
	return axios({
		url: api.gateway_act + 'review_apply/biz/' + `${key}`,
		method: 'get'
	})
}
export function getReimburseApply(key) {
	return axios({
		url: api.gateway_act + 'reimburse_apply/biz/' + `${key}`,
		method: 'get'
	})
}
export function getCarApply(key) {
	return axios({
		url: api.gateway_act + 'biz_car_apply/biz/' + `${key}`,
		method: 'get'
	})
}

export function returnCarApply(key) {
	return axios({
		url: api.gateway_act + 'biz_car_subsidy_apply/biz/' + `${key}`,
		method: 'get'
	})
}

export function getPurchaseByBusiness(key) {
	return axios({
		url: api.gateway_act + 'purchase_apply/biz/' + `${key}`,
		method: 'get'
	})
}

export function previewFileById(param) {
    return axios({
        url: '/file/file/download',
        method: 'post',
        responseType: 'blob', // 必须要写
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
    });
}

export function saveLeave(parameter) {
	return axios({
		url: api.leave + (parameter.id > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}
/**
 * 保存报销申请
 * @param {*} parameter
 */
export function savePurchase(parameter) {
	return axios({
		url: api.purchase + (parameter.id > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}

export function delLeave(parameter) {
	return axios({
		url: api.leave + '/remove',
		method: 'post',
		params: parameter
	})
}

export function getTasking(parameter) {
	return axios({
		url: api.task + '/ing',
		method: 'get',
		params: parameter
	})
}
//我的待办
export function getTaskingData(parameter) {
	return axios({
		url: api.task + '/ing/relate',
		method: 'get',
		params: parameter
	})
}

export function getTaskdone(parameter) {
	return axios({
		url: api.task + '/done',
		method: 'get',
		params: parameter
	})
}
// 我的代办（关联审批）
export function getTaskdoneData(parameter) {
	return axios({
		url: api.task + '/done/relate',
		method: 'get',
		params: parameter
	})
}
//我的或签
export function getOrsign(parameter) {
	return axios({
		url: '/act/business/orsign',
		method: 'get',
		params: parameter
	})
}

export function getTaskdone_cc(parameter) {
	return axios({
		url: api.task + '/done_cc',
		method: 'get',
		params: parameter
	})
}
//关联审批
export function getTaskdone_ccData(parameter) {
	return axios({
		url: api.task + '/done_cc/relate',
		method: 'get',
		params: parameter
	})
}

export function delTaskLogic(parameter) {
	return axios({
		url: api.task + '/remove',
		method: 'post',
		params: parameter
	})
}

/**
 * 任务流转历史
 * @param {} parameter
 */
export function getTaskFlow(parameter) {
	return axios({
		url: api.gateway_act + 'task/flow',
		method: 'get',
		params: parameter
	})
}

/**
 * 获取高亮流程图
 * @param  procInstId 流程实例编号
 */
export function hightlightFlow(procInstId) {
	return pureAxios({
		url: api.process + '/highlightImg/' + `${procInstId}`,
		method: 'get',
		responseType: 'blob'
	})
}

/**
 * 获取流程节点列表
 * @param {String} proDefId 流程定义编号
 */
export function getNodeList(proDefId) {
	return axios({
		url: api.node + '/list/' + `${proDefId}`,
		method: 'get'
	})
}
export function getNodeInfo(nodeId) {
	return axios({
		url: api.node + '/get/' + `${nodeId}`,
		method: 'get'
	})
}
export function updateNodeInfo(parameter) {
	return axios({
		url: api.node + '/update',
		method: 'post',
		data: parameter
	})
}


// ***
//  **报废
export function getScrapByBusiness(key) {
	return axios({
		url: api.scrap + '/biz/' + `${key}`,
		method: 'get'
	})
}

// 审核通过或驳回,推进流程  通用
export function act_task_audit(data) {
	return axios({
		url: api.gateway_act + 'task/audit',
		method: 'post',
		data: data
	})
}

//领用申请
export function getClaimByBusiness(key) {
	return axios({
		url: api.claim + '/biz/' + `${key}`,
		method: 'get'
	})
}
//采购申请通过修改金额
export function update_goods(data) {
	return axios({
		url: api.gateway_act + 'purchase_apply/update/goods',
		method: 'post',
		data: data
	})
}

//编辑评审明细
export function review_apply_info(data) {
	return axios({
		url: api.gateway_act + 'review_apply/info',
		method: 'post',
		data: data
	})
}

// 根据当前用户查询账号
export function get_accounts_receivable(data) {
	return axios({
		url: api.gateway_act + 'accounts_receivable/biz/info',
		method: 'get',
		params: data
	})
}

// 删除文件
export function file_del_java(data) {
	return axios({
		url: '/file/file/delete',
		method: 'get',
		params: data
	})
}

//删除静态资源
export function file_del_java_static(data) {
	return axios({
		url: '/file/file/delete_static',
		method: 'get',
		params: data
	})
}

//新增收款账号
export function accounts_receivable_save(data) {
	return axios({
		url: api.gateway_act + 'accounts_receivable/save',
		method: 'post',
		data: data
	})
}

//删除收款账号
export function accounts_receivable_delete(data) {
	return axios({
		url: api.gateway_act + 'accounts_receivable/delete',
		method: 'post',
		data: data
	})
}


export function get_list_enable(data) {
	return axios({
		url: '/system/districts/list_enable',
		method: 'get',
		params: data
	})
}

export function purchase_apply_downlodPdf(data) {
	return axios({
		url: api.gateway_act + 'purchase_apply/downlodPdf',
		method: 'get',
		params: data
	})
}

export function payment_apply_downlodPdf(data) {
	return axios({
		url: api.gateway_act + 'payment_apply/downlodPdf',
		method: 'get',
		params: data
	})
}
//薪资调整导出
export function salary_adjustment_exportPdf(data) {
	return axios({
		url: api.gateway_act + 'salary_adjustment/export_pdf',
		method: 'get',
		params: data
	})
}

export function reimburse_apply_downlodPdf(data) {
	return axios({
		url: api.gateway_act + 'reimburse_apply/downlodPdf',
		method: 'get',
		params: data
	})
}

export function business_fee_apply_downlodPdf(data) {
	return axios({
		url: api.gateway_act + 'business_fee_apply/downlodPdf',
		method: 'get',
		params: data
	})
}

export function review_apply_downlodPdf(data) {
	return axios({
		url: api.gateway_act + 'review_apply/downlodPdf',
		method: 'get',
		params: data
	})
}

export function cover_apply_downlodPdf(data) {
	return axios({
		url: api.gateway_act + 'cover_apply/downlodPdf',
		method: 'get',
		params: data
	})
}
export function other_apply_downlodPdf(data) {
	return axios({
		url: api.gateway_act + 'other_apply/downlodPdf',
		method: 'get',
		params: data
	})
}

export function scrapped_apply_downlodPdf(data) {
	return axios({
		url: api.gateway_act + 'scrapped_apply/downlodPdf',
		method: 'get',
		params: data
	})
}

export function list_static(data) {
	return axios({
		url: '/file/file/list_static',
		method: 'get',
		params: data
	})
}

export function sys_status_config(data) {
	return axios({
		url: api.gateway_act + 'sys_status_config/status',
		method: 'get',
		params: data
	})
}
// 提交主题
export function changeConfig(data) {
	return axios({
		url: api.gateway_act + 'sys_status_config_new/update',
		method: 'post',
		data: data
	})
}

//转交
export function task_reassignment(data) {
	return axios({
		url: api.gateway_act + 'task/reassignment',
		method: 'post',
		data: data
	})
}
//获取流程列表
export function get_process_all(data) {
	return axios({
		url: '/act/process/process_all',
		method: 'get',
		params: data
	})
}
//流程统计1
export function list_count1(data) {
	return axios({
		url: '/act/business/list_count1',
		method: 'post',
		data: data
	})
}
//流程统计2
export function list_count2(data) {
	return axios({
		url: '/act/business/list_count2',
		method: 'post',
		data: data
	})
}
// 获取关联审批单下拉列表
export function get_audit_list(data) {
	return axios({
		url: '/act/payment_apply/audit_list',
		method: 'get',
		data: data
	})
}
//评论
export function comment(data) {
	return axios({
		url: '/act/comment',
		method: 'post',
		data: data
	})
}
//撤回评论
export function comment_delete(id) {
	return axios({
		url: '/act/comment/' + id,
		method: 'delete',
	})
}
//撤回评论
export function purchase_apply_delete(data) {
	return axios({
		url: '/act/purchase_apply/quote_del',
		method: 'get',
		params: data
	})
}
// 获取保管物品信息
export function keeperAsset(data) {
	return axios({
		url: '/daily/asset/keeperAsset',
		method: 'get',
		params: data
	})
}
// 获取责任物品信息
export function dutyAsset(data) {
	return axios({
		url: '/daily/asset/dutyAsset',
		method: 'get',
		params: data
	})
}
//查询关联检测物质信息
// export function getQuoteTestInfo(data) {
// 	return axios({
// 		url: '/quote/quote/testItem/getQuoteTestInfo',
// 		method: 'get',
// 		params: data
// 	})
// }
// 获取采购编号
export function purchaseCode(data) {
	return axios({
		url: '/act/purchase_apply/code',
		method: 'get',
		params: data
	})
}
// 获取报价信息详情
export function quotationDetail(id) {
	return axios({
		url: '/act/quotation_apply/detail/' + id,
		method: 'get',
	})
}
// 获取合同评审详细信息
export function contractReview(id) {
	return axios({
		url: '/act/contract_review/detail/' + id,
		method: 'get',
	})
}
// 获取项目金额修改申请列表
export function projectAmountList(data) {
	return axios({
		url: '/act/project_amount_apply/list',
		method: 'get',
		params: data

	})
}
//项目金额修改状态
export function updateAgain(data) {
	return axios({
		url: '/act/project_amount_apply/updateAgain',
		method: 'post',
		data: data
	})
}
//重新推送
export function repushEvent(data) {
	return axios({
		url: '/act/nbcb/paymentOrderApiAdd',
		method: 'post',
		data: data
	})
}
//重新推送2
export function singleTransfer(data) {
	return axios({
		url: '/act/nbcb/singleTransfer',
		method: 'post',
		data: data
	})
}
// 获取运营项目信息
export function findProjectInfo(data) {
	return axios({
		url: '/act/findProjectInfo',
		method: 'get',
		params: data

	})
}